import { render, staticRenderFns } from "./ApprovedModal.vue?vue&type=template&id=cc232286&scoped=true"
import script from "./ApprovedModal.vue?vue&type=script&lang=js"
export * from "./ApprovedModal.vue?vue&type=script&lang=js"
import style0 from "./ApprovedModal.vue?vue&type=style&index=0&id=cc232286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc232286",
  null
  
)

export default component.exports